import './App.css';
import './styles/theme.css';

import React from 'react';
import Mission from "./composant/Mission";
import {Link, Route, Routes, useLocation} from "react-router-dom";
import Apropos from "./composant/Apropos";
import NotFound from "./composant/NotFound";
import Home from "./composant/Home";
import Footer from "./composant/Footer";
import Actualite from "./composant/Actualite";
import Particulier from "./composant/Particulier";
import Professionnel from "./composant/Professionnel";
import Contact from "./composant/Contact";
import NousRejoindre from "./composant/NousRejoindre";
import Login from "./composant/Login";
import Admin from "./composant/Admin";
import AdminCandidatures from "./composant/AdminCandidatures";
import ProtectedRoute from "./components/ProtectedRoute";
import {Image, Nav, Navbar, NavDropdown} from "react-bootstrap";
import { Menu, X } from "lucide-react";
import { useAuth } from "./context/AuthContext";

const App = () => {
    const location = useLocation();
    useAuth();
    const [scrolled, setScrolled] = React.useState(false);
    const [navExpanded, setNavExpanded] = React.useState(false);
    
    const isActive = (path) => {
        return location.pathname === path;
    };

    React.useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 10;
            setScrolled(isScrolled);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="app-wrapper d-flex flex-column min-vh-100">
            <Navbar 
                expand="lg" 
                expanded={navExpanded}
                onToggle={setNavExpanded}
                className={`navbar-modern ${scrolled ? 'scrolled' : ''}`}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1030,
                    backgroundColor: scrolled ? 'rgba(248, 250, 252, 0.95)' : 'var(--color-surface)',
                    borderBottom: '1px solid var(--color-border)',
                    boxShadow: scrolled ? 'var(--shadow-md)' : 'var(--shadow-sm)',
                    padding: '1rem 0',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    transition: 'background-color var(--transition-base), box-shadow var(--transition-base)'
                }}
            >
                <div className="container-custom d-flex justify-content-between align-items-center w-100">
                    {/* LOGO - taille fixe (ne change pas au scroll) */}
                    <Navbar.Brand as={Link} to="/" className="me-auto">
                        <Image 
                            src="/GraphiqueCol.png" 
                            className="navbar-logo-img"
                            alt="Moov4Goods Logo"
                            style={{ 
                                cursor: 'pointer',
                                borderRadius: '12px'
                            }}
                        />
                    </Navbar.Brand>

                    {/* Mobile : hamburger pour ouvrir, croix en haut à droite pour fermer */}
                    <button
                        type="button"
                        className="navbar-toggle-custom d-lg-none"
                        aria-controls="basic-navbar-nav"
                        aria-expanded={navExpanded}
                        aria-label={navExpanded ? 'Fermer le menu' : 'Ouvrir le menu'}
                        onClick={() => setNavExpanded(!navExpanded)}
                        style={{
                            border: 'none',
                            background: 'transparent',
                            padding: '0.5rem',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        {navExpanded ? (
                            <X size={28} color="var(--color-primary)" strokeWidth={2} aria-hidden />
                        ) : (
                            <Menu size={28} color="var(--color-primary)" strokeWidth={2} aria-hidden />
                        )}
                    </button>

                    {/* MENUS */}
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                        <Nav className="align-items-center" style={{ gap: '0.5rem' }} onClick={() => setNavExpanded(false)}>
                            <Nav.Link 
                                as={Link} 
                                to="/" 
                                className={`nav-link-modern ${isActive('/') ? 'active' : ''}`}
                            >
                                ACCUEIL
                            </Nav.Link>
                            <NavDropdown 
                                title="NOS SERVICES" 
                                id="basic-nav-dropdown"
                                className="nav-link-modern"
                            >
                                <NavDropdown.Item as={Link} to="/particuliers">
                                    Particuliers
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/professionnels">
                                    Professionnels
                                </NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link 
                                as={Link} 
                                to="/apropos" 
                                className={`nav-link-modern ${isActive('/apropos') ? 'active' : ''}`}
                            >
                                À PROPOS
                            </Nav.Link>
                            <Nav.Link 
                                as={Link} 
                                to="/actualite" 
                                className={`nav-link-modern ${isActive('/actualite') ? 'active' : ''}`}
                            >
                                ACTUALITÉS
                            </Nav.Link>
                            <Nav.Link 
                                as={Link} 
                                to="/mission" 
                                className={`nav-link-modern ${isActive('/mission') ? 'active' : ''}`}
                            >
                                VALEURS & ENGAGEMENT
                            </Nav.Link>
                            <Nav.Link 
                                as={Link} 
                                to="/nous-rejoindre" 
                                className={`nav-link-modern ${isActive('/nous-rejoindre') ? 'active' : ''}`}
                            >
                                NOUS REJOINDRE
                            </Nav.Link>
                            <Nav.Link 
                                as={Link} 
                                to="/contact" 
                                className={`nav-link-modern ${isActive('/contact') ? 'active' : ''}`}
                            >
                                CONTACT
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </div>
            </Navbar>
            
            <main className="main-with-fixed-nav" style={{ flex: 1 }}>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/mission" element={<Mission/>}/>
                    <Route path="/apropos" element={<Apropos/>}/>
                    <Route path="/actualite" element={<Actualite/>}/>
                    <Route path="/particuliers" element={<Particulier/>}/>
                    <Route path="/professionnels" element={<Professionnel/>}/>
                    <Route path="/nous-rejoindre" element={<NousRejoindre/>}/>
                    <Route path="/contact" element={<Contact/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route 
                        path="/admin" 
                        element={
                            <ProtectedRoute>
                                <Admin/>
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        path="/admin/candidatures" 
                        element={
                            <ProtectedRoute>
                                <AdminCandidatures/>
                            </ProtectedRoute>
                        }
                    />
                    <Route path="*" element={<NotFound/>}/>
                </Routes>
            </main>

            <Footer/>
        </div>
    );
};


export default App;
